import { cloneElement, useId, type ReactElement, type ReactNode } from 'react';
import { cx } from './cx';
import styles from './Tooltip.module.css';

export type TooltipPlacement = 'top' | 'bottom' | 'bottom-end' | 'top-end' | 'right';

interface TooltipProps {
  readonly content: ReactNode;
  readonly placement?: TooltipPlacement;
  readonly children: ReactElement<{ 'aria-describedby'?: string }>;
}

/**
 * CSS-driven tooltip: shown on hover and keyboard focus of the wrapped control, including
 * disabled controls (hover is tracked on the wrapper). The text is linked through
 * `aria-describedby` so screen readers announce it.
 */
export function Tooltip({ content, placement = 'bottom', children }: TooltipProps) {
  const id = useId();
  return (
    <span className={styles.wrapper}>
      {cloneElement(children, { 'aria-describedby': id })}
      <span role="tooltip" id={id} className={cx(styles.tooltip, styles[placement])}>
        {content}
      </span>
    </span>
  );
}
